import script from "./TransactionViewDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransactionViewDialog.vue?vue&type=script&setup=true&lang=ts"

import "./TransactionViewDialog.vue?vue&type=style&index=0&id=f74bacdc&scoped=true&lang=css"
import "./TransactionViewDialog.vue?vue&type=style&index=1&id=f74bacdc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f74bacdc"]])

export default __exports__